<div id="fb-root"></div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <a class="navbar-brand flex" href="#">
        <div class="d-flex">
          <img src="assets/BN_Mini_Logo.png" width="50" height="50" class="d-block align-top" alt="">
          <h3 class="d-none d-md-inline d-lg-none" style="margin-left: 1em;margin-top:0.5rem; height:100%">Blazing Needles Home Furnishings</h3>
          <h3 class="d-inline d-md-none" style="margin-left: 1em;margin-top:0.5rem; height:100%">Blazing Needles Home</h3>
        </div>
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
         <!-- <li class="nav-item active">
            <a class="nav-link" href="#/home">Home <span class="sr-only">(current)</span></a>
          </li> -->
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Product Categories
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown"  style="width:200%;min-width:31.25px;border-top-left-radius:0;border-top-right-radius:0px;margin:0">
              <a class="dropdown-item" href="#/categories/Outdoor">Outdoor Categories</a>
              <a  class="dropdown-item" href="#/categories/Indoor">Indoor Categories</a>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/fabriccollections">Fabric Collections</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#/ourpartners">E-Retail Partners</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              About Us
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown"  style="width:200%;min-width:31.25px;border-top-left-radius:0;border-top-right-radius:0px;margin:0">
              <a class="dropdown-item" href="#/aboutus">Our Story</a>
              <a class="dropdown-item" href="#/contactus">Contact Us</a>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://www.internationalcaravan.com" style="color:rgb(52, 153, 236)"><img src="assets/ICI_Logo.png" width="20" height="20" alt="">International Caravan</a>
          </li>
        </ul>
          <form (submit)="submit(searchstring)" class="form-inline my-2 my-lg-0">
            <div class="input-group">
              <input class="form-control" [(ngModel)]="searchstring" name="search" type="search" placeholder="Search our catalog..." aria-label="Search" style="width:16rem">
              <div class="input-group-append">
              <button class="btn btn-info my-2 my-sm-0" type="submit" style="background-color: #EC5734;border-color: rgb(199, 72, 44)"><a style="color: inherit;" href="#/browseproducts/search/{{searchstring.split(' ').join('_')}}">Search</a></button>
            </div>
            </div>
          </form>
      </div>
    </nav>